import { ArrowLeft, Check, type LucideIcon } from 'lucide-react'
import { Link } from './nav'
import './SetupPage.css'

export type SetupBadge = { tone: 'success' | 'warning' | 'neutral'; label: string }

export default function SetupPageHeader({ projectId, icon: Icon, title, description, badge }: {
  projectId: string; icon: LucideIcon; title: string; description: string; badge?: SetupBadge | null
}) {
  return <>
    <Link to={`/projects/${projectId}/overview`} className="setup-page__back"><ArrowLeft size={14} aria-hidden />Overview</Link>
    <header className="setup-page__header">
      <span className="setup-page__icon"><Icon size={20} strokeWidth={1.75} aria-hidden /></span>
      <div className="setup-page__heading">
        <h1>
          {title}
          {badge && <span className={`setup-badge setup-badge--${badge.tone}`}>
            {badge.tone === 'success' && <Check size={12} strokeWidth={2.5} aria-hidden />}{badge.label}
          </span>}
        </h1>
        <p>{description}</p>
      </div>
    </header>
  </>
}
